<div [ngClass]="{'wrap-product-name': wrapProductName}">
  {{ candidate.product }}
  <app-copy-to-clipboard *ngIf="showCopy" [text]="candidate.product" />
</div>
<div class="small">
  <strong>NDC:</strong> {{ candidate.ndc }} <span class="flagged-for-esp p-1" *ngIf="isFlaggedForEsp">ESP</span>
  <app-copy-to-clipboard *ngIf="showCopy" [text]="candidate.ndc" />
</div>
